import {
  faBox,
  faComments,
  faCar,
  faShoppingCart,
  faFire,
  faWallet,
  faHeartbeat,
  faTools,
  faCity,
  faDesktop,
  faLightbulb,
} from '@fortawesome/free-solid-svg-icons';

const ICONS = {
  'Basic Materials': faBox,
  'Communication Services': faComments,
  'Consumer Cyclical': faCar,
  'Consumer Defensive': faShoppingCart,
  Energy: faFire,
  'Financial Services': faWallet,
  Healthcare: faHeartbeat,
  Industrials: faTools,
  'Real Estate': faCity,
  Technology: faDesktop,
  Utilities: faLightbulb,
};

export default ICONS;
